import keycloak from 'src/keycloak';
import { OrganizationRepresentation } from 'src/query/orgs';

export const defaultRoles = [
  'view-organization',
  'manage-organization',
  'view-members',
  'manage-members',
  'view-roles',
  'manage-roles',
  'view-invitations',
  'manage-invitations',
  'view-identity-providers',
  'manage-identity-providers',
] as const;

type Role = typeof defaultRoles[number];

// Checks if user has all roles passed
export function checkUserRolesForOrg(roles: Role[], orgId: OrganizationRepresentation['id']): boolean {
  const checkRoles = roles.map((role) => checkUserRoleForOrg(role, orgId));
  return !checkRoles.includes(false);
}

export function checkUserRoleForOrg(role: Role, orgId: OrganizationRepresentation['id']): boolean {
  const token = keycloak.tokenParsed!;
  return token.organizations[orgId]?.roles?.includes(role);
}

export function checkUserAllDefaultRolesForOrg(orgId: OrganizationRepresentation['id']): boolean {
  return checkUserRolesForOrg(defaultRoles, orgId);
}
